import React from "react";
import "../styles/AcknowledgePage.scss";
import acknowledge from "../assets/Logo_Image-removebg-preview.png";

function AcknowledgePage() {
  return (
    <div className="acknowledge-container">
      <div className="acknowledge-details">
        <div className="acknowledge-text">
          The PEN Scholar Awards 2025, held on March 28, 2025, was a grand celebration of academic excellence and groundbreaking research in the field of Social Sciences. 
          The event was honored by the esteemed presence of <strong>Dr. Govi. Chezhiaan</strong>, Hon’ble Minister for Higher Education, Tamil Nadu, and <strong>Dr. M. Suresh Babu</strong>, Director of the Madras Institute of Development Studies. Scholars and Academicians graced the occasion with their valuable insights and support.
        </div>
        <div className="acknowledge-img">
          <img src={acknowledge} alt="acknowledge" />
        </div>
      </div>
    </div>
  );
}


export default AcknowledgePage;
